import { ParagraphSkeleton } from './ParagraphSkeleton';

export const CarouselSkeleton = () => {
  return (
    <div className='flex flex-col gap-3 items-center w-full'>
      <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4 w-full'>
        <div className='border border-line overflow-hidden'>
          <div className='aspect-video skeleton'></div>
          <ParagraphSkeleton className='p-5 md:p-7' columns={[12, 10, 7]} />
        </div>
        <div className='border border-line overflow-hidden hidden sm:block'>
          <div className='aspect-video skeleton'></div>
          <ParagraphSkeleton className='p-5 md:p-7' columns={[12, 10, 7]} />
        </div>
        <div className='border border-line overflow-hidden hidden md:block'>
          <div className='aspect-video skeleton'></div>
          <ParagraphSkeleton className='p-5 md:p-7' columns={[12, 10, 7]} />
        </div>
      </div>
      <div className='slider-nav-container'>
        <div className='flex gap-2 mx-auto'>
          <div className='slider-button skeleton pointer-events-none'></div>
          <div className='slider-button skeleton pointer-events-none'></div>
          <div className='slider-button skeleton pointer-events-none'></div>
        </div>
      </div>
    </div>
  );
};
